export default {
  title: 'HiTeach classroom games',
  pvpGame: 'Sweeping Stars',
  moleGame: 'Whack-a-Mole',
  tfGame: 'Rocket Launch',
  pickGame: 'Pick Wheel',
  punchBoardGame: 'Punch Board',
  
  // Game info title
  gameInfoTitle: 'Game Information',
  close: 'Close',
  
  // Vocabulary Drop description
  pvpGameTitle: 'Sweeping Stars',
  pvpGameDesc: 'On a tropical island, words fall from the sky like meteor showers!\nTwo players must catch correct words and avoid wrong ones within a time limit. Who can become the vocabulary hunter king with speed and precision?',
  
  // Whack-a-Mole description
  moleGameTitle: 'Whack-a-Mole',
  moleGameDesc: 'Single player battle! The knowledge version of Whack-a-Mole is here~\nMoles pop up with true and false information. Can you accurately "knock out" the correct answers in the shortest time and defeat those troublesome errors?',
  
  // Rocket Launch description
  tfGameTitle: 'Rocket Launch',
  tfGameDesc: 'Prepare for liftoff, knowledge duel activated!\nTwo astronauts face true-false question challenges. Correct answers propel your rocket toward the stars, wrong answers make you spin in place~ Who can be the first to fly beyond the atmosphere and become a knowledge astronaut?',
  
  // Pick Wheel description
  pickGameTitle: 'Pick Wheel',
  pickGameDesc: 'Spin the wheel of destiny!\nSupports individual picking, group picking, or custom options. Make choices more fun and fair. Wheel spins, answer reveals!',
  
  // Punch Board description
  punchBoardGameTitle: 'Punch Board',
  punchBoardGameDesc: 'Punch through to surprises!\nEach hole hides different surprises. Break through the surface to explore content. Supports various board sizes and animation effects, making choices full of anticipation!',
  
  // Button text
  play: 'Start Game'
}